export const formName = "autoAnnotate";
